<template>
  <dv-scroll-board :config="config" style="width:100%;height:100%;" />
</template>

<script>
export default {
  name: "SellList1",
  data() {
    return {
      config: {},
    }
  },
  methods:{

  },
  created() {
   
      let data=[];
      data[0]=['市社会组织孵化基地(社会组织之家)','消费助农产品展示中心','乡村规划设计院','村振兴工作委员会','金雀爱心基金'];
      data[1]=['大学生校外实践教育基地','会议会展中心','乡村规划设计院','筹建市乡村振兴协会','金雀爱心基金'];
      data[2]=['文创基地','县域商业运营中心','乡村规划设计院','村振兴工作委员会','金雀爱心基金'];
      data[3]=['社会组织助力乡村振兴示范基地','消费助农产品展示中心','乡村规划设计院','筹建市乡村振兴协会','金雀爱心基金'];
      data[4]=['黄淮学院乡村振兴学院金雀培训基地','会议会展中心','乡村规划设计院','筹建市乡村振兴协会','金雀爱心基金'];
      data[5]=['金雀田园高效农业示范基地','消费助农产品展示中心','乡村规划设计院','村振兴工作委员会','金雀爱心基金'];
      data[6]=['直播基地','县域商业运营中心','乡村规划设计院','筹建市乡村振兴协会','金雀爱心基金'];
      data[7]=['农特产品深加工物流基地','县域商业运营中心','乡村规划设计院','村振兴工作委员会','金雀爱心基金'];
      this.config = {
        header: ['基地名称','中心','乡村规划设计机构','协会名称', '基金名称'],
        rowNum:[4],
        data: data,
        headerBGC: '#0081EE',
        oddRowBGC: '#0e0e26',
        evenRowBGC: '#0e0e26',
        index: true,
        columnWidth: [50,350],
        align: ['center']
      }
   


  },

  watch: {

  }
}
</script>

<style scoped>

</style>